export const DELIVERY_STATUS = {
    NO_PROCESS: 'NO_PROCESS',
    PROCESSING: 'PROCESSING',
    PROCESSED: 'PROCESSED',
}
